const SOMETHING_WROING = 'Something wrong';
const SOMETHING_WARNING = 'Warning';
const SOMETHING_SORRY_ID = 1296;
const SOMETHING_SORRY_MESSAGE = 'Maaf';
const SUCCESS_MESSAGE = 'Success';
const FAILED_MESSAGE = 'Failed';
const COMPLETED_MESSAGE = 'Completed';
const ARE_YOU_SURE = 'Are you sure?';
const CONFIRM_CANNOT_COMEBACK = 'Once you confirm it, it can not call back';
const RECORD_IS_UPDATED = 'Record is updated';
const RECORD_IS_CREATED = 'Record is created';
const CONFIRM_DELETE_ITEM = 'You will delete the item';
const RECORD_IS_DELETED = 'Record is deleted';
const STATUS_ERROR = 'error';
const STATUS_WARNING = 'warning';
const STATUS_SUCCESS = 'success';
const UPPER_SUCCESS = 'SUCCESS';
const UPPER_CANCELLED = 'CANCELLED';
const UPPER_BAD = 'BAD';
const STATUS_200 = 200;
const STATUS_200_STRING = '200';
const STATUS_OK_UPPER = 'OK';
const FAILED_COUPON = 'unavailable coupon';
const PERMISSION_E = 'E';
const PERMISSION_D = 'D';
const PERMISSION_N = 'N';
const PPDI = 'PPDI';
const PPTA = 'PPTA';
const HMD = 'HMD';
const TOP = 'TOP';
const OTHERS = 'OTHERS';
const POS = 'POS';
const QRO = 'QRO';
const ROOM = 'ROOM';
const ALL = 'ALL';
const QR_TYPE = ['QRPay', 'Qris-GoPay', 'Qris-ShopeePay', 'Astrapay'];
const DEFAULT_USER_ID = '970911';
const PRINT_INTERVAL = 5; // Auto Print Interval, Unit: second
const MAX_CONTRACTS = 1;
const DEFAULT_AGE_RANGE = [
  '0-9',
  '10-19',
  '20-29',
  '30-39',
  '40-49',
  '50-59',
  '60-69',
  '70-79',
  '80-89',
  '90-99',
  '100-109'
];
const TAGGING_GENDER = [
  { value: 1, text: 'Pria' }, // Male
  { value: 2, text: 'Wanita' } // Female
];
const DEFAULT_ETHNICITY_OPTIONS = [
  'Chinese - indo',
  'Western',
  'Indonesian',
  'Japanese',
  'Korean',
  'Indian',
  'Other'
];
const DEFAULT_OCCASIONS_OPTIONS = [
  'Large Gatherings',
  'Family Gathering',
  'Couple Dating',
  'Personal'
];
const DEFAULT_FOOD_PREFERENCES_OPTIONS = [
  'Pork Eater',
  'Alcohol Drinker'
];
const MEMBER_STATUS_OPTIONS = [
  {
    value: 1,
    text: 'WhatsApp'
  },
  {
    value: 2,
    text: 'No WhatsApp'
  }
];
const MAX_PRICE = 1000000000;
const EDC_ONLINE_PAYMENT = { ottopay: 0, debit: 0, credit: 0 };
const EDC_CIMB_PAYMENT = { qris: 0, debit: 0, credit: 0 };
const EDC_OFFLINE_PAYMENT = { cash: 0, bca: 0, mandiri: 0, bri: 0, ovo: 0, bank: 0, tiktok_go: 0, psychology: 0, sexology: 0, dermatology_aesthetic: 0, andrology: 0, medical_slimming_wellness: 0, legend_match: 0 };
const Y_OR_N_OPTIONS = [{ text: 'Yes', value: 1 }, { text: 'No', value: 0 }];

const VendorOptions = [
  { value: 'damcorp', text: 'Damcorp' },
  { value: 'qiscus', text: 'Qiscus' }
]
const LanguageOptions = [
  { value: 'en', text: 'English' },
  { value: 'id', text: 'Indonesian' }
]
const DefaultVendor = VendorOptions[0].value
const DefaultLanguage = LanguageOptions[1].value

const EDC_OFFLINE_PAYMENT_OPTIONS = [
  {
    key: 'cash',
    value: 'Edc-Cash',
    text: 'Cash',
    type: 'other',
    img: require('@/assets/edc/cash-payment.png'),
  },
  {
    key: 'mandiri',
    value: 'Edc-Mandiri',
    text: 'EDC Mandiri',
    type: 'other',
    img: require('@/assets/edc/edc-payment.png'),
  },
  {
    key: 'bca',
    value: 'Edc-Bca',
    text: 'EDC BCA',
    type: 'other',
    img: require('@/assets/edc/edc-payment.png'),
  },
  {
    key: 'bri',
    value: 'Edc-Bri',
    text: 'EDC BRI',
    type: 'other',
    img: require('@/assets/edc/edc-payment.png'),
  },
  {
    key: 'ovo',
    value: 'Edc-Ovo',
    text: 'EDC OVO',
    type: 'other',
    img: require('@/assets/edc/edc-ovo.png'),
  },
  {
    key: 'mega',
    value: 'Edc-Bank-Mega',
    text: 'EDC - Bank Mega',
    type: 'other',
    img: require('@/assets/edc/edc-bank-mega.png'),
  },
  {
    key: 'bank',
    value: 'Edc-Bank-Transfer',
    text: 'Bank Transfer',
    type: 'other',
    img: require('@/assets/edc/bank-transfer-payment.png'),
  },
  {
    key: 'shopeepay',
    value: 'Edc-Shopeepay',
    text: 'EDC - Shopeepay',
    type: 'other',
    img: require('@/assets/edc/edc-shopeepay.png'),
  },
  {
    key: 'gopay',
    value: 'Edc-Gopay',
    text: 'EDC - Gopay',
    type: 'other',
    img: require('@/assets/edc/edc-gopay.png'),
  },
  {
    key: 'tiktok_go',
    value: 'EDC-TikTok-Go',
    text: 'TikTok Go',
    type: 'other',
    img: require('@/assets/edc/tiktok-go.png'),
  },
  {
    key: 'psychology',
    value: 'EDC-Psychology',
    text: 'Psychology',
    type: 'other',
    img: require('@/assets/edc/psychology.png'),
  },
  {
    key: 'sexology',
    value: 'EDC-Sexology',
    text: 'Sexology',
    type: 'other',
    img: require('@/assets/edc/sexology.png'),
  },
  {
    key: 'dermatology_aesthetic',
    value: 'EDC-Dermatology-Aesthetic',
    text: 'Dermatology Aesthetic',
    type: 'other',
    img: require('@/assets/edc/dermatology-aesthetic.png'),
  },
  {
    key: 'andrology',
    value: 'EDC-Andrology',
    text: 'Andrology',
    type: 'other',
    img: require('@/assets/edc/andrology.png'),
  },
  {
    key: 'medical_slimming_wellness',
    value: 'EDC-Medical-Slimming-Wellness',
    text: 'Medical Slimming & Wellness',
    type: 'other',
    img: require('@/assets/edc/medical-slimming-wellness.png'),
  },
  {
    key: 'legend_match',
    value: 'EDC-Legend-Match',
    text: 'Legend match',
    type: 'other',
    img: require('@/assets/edc/legend-match.png'),
  },
  {
    key: 'bni',
    value: 'Edc-Bni',
    text: 'EDC - BNI',
    type: 'other',
    img: require('@/assets/edc/edc-BNI.png'),
  },
  {
    key: 'btn',
    value: 'Qris-Btn',
    text: 'QRIS - BTN',
    type: 'other',
    img: require('@/assets/edc/qris-payment.png'),
  },
  {
    key: 'dana',
    value: 'QRIS-Dana',
    text: 'QRIS - Dana',
    type: 'other',
    img: require('@/assets/edc/qris-dana.png'),
  },
  {
    key: 'youtap',
    value: 'EDC-Youtap',
    text: 'EDC - Youtap',
    type: 'other',
    img: require('@/assets/edc/edc-youtap.png'),
  },
  {
    key: 'niaga',
    value: 'EDC-CIMB-Niaga',
    text: 'EDC - CIMB Niaga',
    type: 'other',
    img: require('@/assets/edc/edc-CIMB-niaga.png'),
  },
  {
    key: 'moka',
    value: 'EDC-Moka',
    text: 'EDC - Moka',
    type: 'other',
    img: require('@/assets/edc/edc-moka.png'),
  },
  {
    key: 'yokke',
    value: 'EDC-Yokke',
    text: 'EDC - Yokke',
    type: 'other',
    img: require('@/assets/edc/edc-yokke.png'),
  },
  {
    key: 'ocbc',
    value: 'EDC-OCBC',
    text: 'EDC - OCBC',
    type: 'other',
    img: require('@/assets/edc/edc-ocbc.png'),
  },
  {
    key: 'panin',
    value: 'EDC-Panin',
    text: 'EDC - Panin',
    type: 'other',
    img: require('@/assets/edc/edc-panin.png'),
  },
  {
    key: 'danamon',
    value: 'EDC-Danamon',
    text: 'EDC - Danamon',
    type: 'other',
    img: require('@/assets/edc/edc-danamon.png'),
  },
  {
    key: 'sinarmas',
    value: 'EDC-Sinarmas',
    text: 'EDC - Sinarmas',
    type: 'other',
    img: require('@/assets/edc/edc-sinarmas.png'),
  },
  {
    key: 'qBiz',
    value: 'EDC-QBiz',
    text: 'EDC - QBiz',
    type: 'other',
    img: require('@/assets/edc/edc-qBiz.png'),
  },
  {
    key: 'permata',
    value: 'EDC-Permata',
    text: 'EDC - Permata',
    type: 'other',
    img: require('@/assets/edc/edc-permata.png'),
  },
  {
    key: 'cc-bca',
    value: 'EDC-CC-Bca-Putih',
    text: 'EDC - CC BCA Putih',
    type: 'other',
    img: require('@/assets/edc/edc-cc-bca.png'),
  },
  {
    key: 'bca-debit',
    value: 'EDC-Bca-Debit',
    text: 'EDC - BCA Debit',
    type: 'other',
    img: require('@/assets/edc/edc-cc-bca.png'),
  },
  {
    key: 'bca-card',
    value: 'EDC-Bca-Card',
    text: 'EDC - BCA Card',
    type: 'other',
    img: require('@/assets/edc/edc-cc-bca.png'),
  },
  {
    key: 'mandiri-debit',
    value: 'EDC-Mandiri-Debit',
    text: 'EDC - Mandiri Debit',
    type: 'other',
    img: require('@/assets/edc/edc-mandiri.png'),
  },
  {
    key: 'mandiri-card',
    value: 'EDC-Mandiri-Card',
    text: 'EDC - Mandiri Card',
    type: 'other',
    img: require('@/assets/edc/edc-mandiri.png'),
  },
  {
    key: 'bni-debit',
    value: 'EDC-Bni-Debit',
    text: 'EDC - BNI Debit',
    type: 'other',
    img: require('@/assets/edc/edc-BNI.png'),
  },
  {
    key: 'bni-card',
    value: 'EDC-Bni-Card',
    text: 'EDC - BNI Card',
    type: 'other',
    img: require('@/assets/edc/edc-BNI.png'),
  },
  {
    key: 'bli-bli',
    value: 'EDC-Blibli',
    text: 'EDC - BliBli',
    type: 'other',
    img: require('@/assets/edc/edc-blibli.png'),
  },
  {
    key: 'kredivo',
    value: 'EDC-Kredivo',
    text: 'EDC - Kredivo',
    type: 'other',
    img: require('@/assets/edc/edc-kredivo.png'),
  },
  {
    key: 'edc-qris',
    value: 'EDC-Qris',
    text: 'EDC - QRIS',
    type: 'other',
    img: require('@/assets/edc/qris-payment.png'),
  },
  {
    key: 'qpon',
    value: 'QPon',
    text: 'QPon',
    type: 'other',
    img: require('@/assets/edc/edc-qpon.png'),
  },
  {
    key: 'other',
    value: 'EDC-Other',
    text: 'EDC - Other',
    type: 'other',
    img: require('@/assets/edc/edc-payment.png'),
  },
  {
    key: 'website',
    value: 'Website',
    text: 'Website',
    type: 'other',
    img: require('@/assets/edc/website.png'),
  },
  {
    key: 'no-sale',
    value: 'No-Sale',
    text: 'No Sale',
    type: 'other',
    img: require('@/assets/edc/no-sale.png'),
  },
]

const EDC_ORDER_MODEL = {
  checkCoupon: 'checkCoupon'
}

const HOME_SCREEN_STEPS_CONFIG = {
  transaksiMember: {
    title: 'Transaksi Member',
    key: 'transaksiMember',
  },
  memberEDC: {
    title: 'Member EDC',
    key: 'memberEDC',
  },
  totalPayment: {
    title: 'Total Payment',
    key: 'totalPayment',
  },
  posOrderPhone: {
    title: 'POS Order Phone',
    key: 'posOrderPhone',
  },
  posOrderPromo: {
    title: 'POS Order Promo',
    key: 'posOrderPromo',
  },
}

const DEFAULT_HOME_SCREEN_STEPS = [
  HOME_SCREEN_STEPS_CONFIG.transaksiMember,
  HOME_SCREEN_STEPS_CONFIG.memberEDC,
  HOME_SCREEN_STEPS_CONFIG.totalPayment,
  HOME_SCREEN_STEPS_CONFIG.posOrderPhone,
  HOME_SCREEN_STEPS_CONFIG.posOrderPromo,
]

const HOME_SCREEN_STEPS_PHONE_FIRST = [
  HOME_SCREEN_STEPS_CONFIG.transaksiMember,
  HOME_SCREEN_STEPS_CONFIG.posOrderPhone,
  HOME_SCREEN_STEPS_CONFIG.posOrderPromo,
  HOME_SCREEN_STEPS_CONFIG.memberEDC,
  HOME_SCREEN_STEPS_CONFIG.totalPayment,
]

const EDC_ORDER_FLOW = [
  {
    text: 'Payment First Flow (Choose Payment → Amount → Phone)',
    value: 0,
  },
  {
    text: 'Phone First Flow (Phone → User → Coupon → Choose Payment → Amount)',
    value: 1,
  },
]

const MESSAGE_SEND_TYPE = [
  {
    text: 'All',
    value: 0,
  },
  {
    text: 'WhatsApp',
    value: 1,
  },
]

const LEVEL = {
  period: {
    monthly: 'Month',
    quarterly: 'Quarter',
    semester: 'Semester',
    yearly: 'Year',
  },
  unit: {
    spending: 'Spend',
    point: 'Point',
  },
}

export default {
  SOMETHING_WROING,
  SOMETHING_WARNING,
  SUCCESS_MESSAGE,
  FAILED_MESSAGE,
  COMPLETED_MESSAGE,
  ARE_YOU_SURE,
  CONFIRM_CANNOT_COMEBACK,
  RECORD_IS_UPDATED,
  RECORD_IS_CREATED,
  CONFIRM_DELETE_ITEM,
  RECORD_IS_DELETED,
  STATUS_ERROR,
  STATUS_WARNING,
  STATUS_SUCCESS,
  UPPER_SUCCESS,
  UPPER_CANCELLED,
  UPPER_BAD,
  STATUS_200,
  STATUS_200_STRING,
  STATUS_OK_UPPER,
  FAILED_COUPON,
  PERMISSION_E,
  PERMISSION_D,
  PERMISSION_N,
  PPDI,
  PPTA,
  HMD,
  TOP,
  OTHERS,
  QRO,
  ROOM,
  ALL,
  POS,
  QR_TYPE,
  DEFAULT_USER_ID,
  PRINT_INTERVAL,
  MAX_CONTRACTS,
  DEFAULT_AGE_RANGE,
  TAGGING_GENDER,
  MAX_PRICE,
  EDC_ONLINE_PAYMENT,
  EDC_CIMB_PAYMENT,
  EDC_OFFLINE_PAYMENT,
  Y_OR_N_OPTIONS,
  VendorOptions,
  LanguageOptions,
  DefaultVendor,
  DefaultLanguage,
  EDC_OFFLINE_PAYMENT_OPTIONS,
  EDC_ORDER_MODEL,
  SOMETHING_SORRY_ID,
  SOMETHING_SORRY_MESSAGE,
  HOME_SCREEN_STEPS_CONFIG,
  DEFAULT_HOME_SCREEN_STEPS,
  DEFAULT_ETHNICITY_OPTIONS,
  DEFAULT_OCCASIONS_OPTIONS,
  DEFAULT_FOOD_PREFERENCES_OPTIONS,
  HOME_SCREEN_STEPS_PHONE_FIRST,
  MEMBER_STATUS_OPTIONS,
  EDC_ORDER_FLOW,
  MESSAGE_SEND_TYPE,
  LEVEL,
}
